import { axiosClientAdmin } from '@/lib/auth';

export enum EnumArmingEventType {
  'Armed' = 'Armed',
  'Disarmed' = 'Disarmed',
}

export interface CalendarDto {
  region?: string;
  calendarId?: string;
  events?: CalendarEventDto[];
}

export interface CalendarEventCrudded {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  calendarEvent?: CalendarEventDto;
}

export interface CalendarEventDto {
  id?: string;
  startDate?: Date;
  endDate?: Date;
  isEnabled?: boolean;
  isPreset?: boolean;
  name?: string;
  description?: string;
  verificationId?: string;
  armingEventType?: EnumArmingEventType;
}

export interface CalendarEventsFetched {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  region?: string;
  calendarEvents?: CalendarEventDto[];
}

export interface CalendarIdFetched {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  calendarId?: string;
}

export interface RegionalCalendarDto {
  region?: string;
  calendarId?: string;
}

export interface CalendarRegionCrudded {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  calendar?: RegionalCalendarDto;
}

export interface CalendarRegionSet {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
}

export interface CalendarRegionsFetched {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  regions?: RegionalCalendarDto[];
}

interface Event extends CalendarEventDto {
  name: string;
  start: string;
  end: string;
  timed: boolean;
  color: string;
  details: string;
}

export const createEventCalendar = async (
  calendarId: string,
  data?: CalendarEventDto
): Promise<CalendarEventCrudded> => {
  try {
    const response = await axiosClientAdmin.post<CalendarEventCrudded>(
      `/Calendar/${calendarId}/create`,
      data
    );

    if (!response.data) {
      throw new Error('No data received from server');
    }

    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data?.message || 'Failed to create calander event');
    }
    throw new Error('Failed to create calander event');
  }
};

export const updateEventCalendar = async (
  calendarId: string,
  data?: CalendarEventDto
): Promise<CalendarEventCrudded> => {
  try {
    const response = await axiosClientAdmin.post<CalendarEventCrudded>(
      `/Calendar/${calendarId}/updateEvent`,
      data
    );

    if (!response.data) {
      throw new Error('No data received from server');
    }

    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data?.message || 'Failed to update calander event');
    }
    throw new Error('Failed to update calander event');
  }
};

export const deleteEventCalendar = async (
  calendarId: string,
  data?: CalendarEventDto
): Promise<CalendarEventCrudded> => {
  try {
    const response = await axiosClientAdmin.delete<CalendarEventCrudded>(
      `/Calendar/${calendarId}/delete`,
      { data: data }
    );

    if (!response.data) {
      throw new Error('No data received from server');
    }

    console.log('Deleted Success', response.data);

    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data?.message || 'Failed to delete calander event');
    }
    throw new Error('Failed to delete calander event');
  }
};

export const getCalendarIdCalendar = async (projectId: string): Promise<CalendarIdFetched> => {
  try {
    const response = await axiosClientAdmin.get<CalendarIdFetched>(
      `/Calendar/${projectId}/calendar`
    );

    if (!response.data) {
      throw new Error('No data received from server');
    }

    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data?.message || 'Failed to get calendar');
    }
    throw new Error('Failed to get calendar');
  }
};

export const getCalendarEvents = async (calendarId: string): Promise<CalendarEventsFetched> => {
  try {
    const response = await axiosClientAdmin.get<CalendarEventsFetched>(
      `/Calendar/${calendarId}/events`
    );

    if (!response.data) {
      throw new Error('No data received from server');
    }

    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data?.message || 'Failed to get calendar events');
    }
    throw new Error('Failed to get calendar events');
  }
};
